<div class="unauthorized">
  <dsy-styled-text>
    <h1>{{ 'PD.UNAUTHORIZED.TITLE' | translate }}</h1>
    <p>{{ 'PD.UNAUTHORIZED.MESSAGE' | translate }}</p>
  </dsy-styled-text>
</div>
